"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModeStyles = exports.isDateSelected = exports.isWeekend = exports.isBeginningOfWeek = exports.getEndOfMonth = exports.getBeginningOfMonth = void 0;
var luxon_1 = require("luxon");
var defaultLabel = {
    top: {
        date: "",
        fontSize: 0,
        fontStyle: "",
    },
    bottom: {
        date: "",
        fontSize: 15,
        fontStyle: "",
    },
};
var MONDAY = 1;
var FRIDAY = 5;
function getBeginningOfMonth(date) {
    return luxon_1.DateTime.fromISO(date, { zone: "utc" }).startOf("month").startOf("day");
}
exports.getBeginningOfMonth = getBeginningOfMonth;
function getEndOfMonth(date) {
    return luxon_1.DateTime.fromISO(date, { zone: "utc" }).endOf("month").startOf("day");
}
exports.getEndOfMonth = getEndOfMonth;
function isBeginningOfWeek(day) {
    return day === MONDAY;
}
exports.isBeginningOfWeek = isBeginningOfWeek;
function isWeekend(day) {
    return day > FRIDAY;
}
exports.isWeekend = isWeekend;
function isDateSelected(currDate, selectedDate) {
    return selectedDate
        ? Math.round(currDate.diff(luxon_1.DateTime.fromISO(selectedDate, { zone: "utc" }), "days")
            .days) === 0
        : false;
}
exports.isDateSelected = isDateSelected;
function getModeStyles(date, mode) {
    if (mode === "months") {
        return createMonthsLabels(date);
    }
    if (mode === "days") {
        return createDaysLabels(date);
    }
    return defaultLabel;
}
exports.getModeStyles = getModeStyles;
function createMonthsLabels(date) {
    var fontSize = 14;
    var fontStyle = "normal";
    var dateLabel = date.toFormat("d");
    var dayLabel = date.toFormat("EEEEE");
    return {
        top: createDateLabelDate(dateLabel, fontSize, fontStyle),
        bottom: createDateLabelDate(dayLabel, fontSize, fontStyle),
    };
}
function createDaysLabels(date) {
    var fontSize = 14;
    var fontStyle = "normal";
    var dayLabel = date.toFormat("ccc");
    var dateLabel = date.toFormat("LLL") + " " + date.toFormat("d");
    return {
        top: createDateLabelDate(dayLabel, fontSize, fontStyle),
        bottom: createDateLabelDate(dateLabel, fontSize, fontStyle),
    };
}
var createDateLabelDate = function (date, fontSize, fontStyle) { return ({ date: date, fontSize: fontSize, fontStyle: fontStyle }); };
